export enum IS_ACCESS {
  Yes = 1,
  No = 2,
}

export enum IS_AUTO_INVOICE {
  enable = 1,
  disable = 2,
}

export enum PRODUCT_TYPE {
  Inventory = 1,
  KStore = 2,
}

export enum DELIVERY_TYPE {
  Door_Delivery = 1,
  Customer_Pickup = 2,
  Both = 3,
}
